import { Provider } from "react-redux";
import { store } from "./store";

import { TelegramProvider } from "./telegram/TelegramProvider";

export function AppProviders({ children }: { children: React.ReactNode }) {
    return (
        <Provider store={store}>
            <TelegramProvider>{children}</TelegramProvider>
        </Provider>
    );
}
